import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Package } from '../../../ship/models/package.model';


import moment from 'moment';

@Component({
  selector: 'upsc-ship-details-dialog',
  templateUrl: './ship-details-dialog.component.html',
  styleUrls: ['./ship-details-dialog.component.scss'],
})
export class ShipDetailsDialogComponent implements OnInit {
  public quote: Package;
  public isShowTrackingDetailsTable = false;

  constructor(public dialogRef: MatDialogRef<ShipDetailsDialogComponent>,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.quote = data.quote;
  }

  public ngOnInit() {
  }

  public simplifyDate(date: Date) {
    return moment(date).format('M/D/YYYY');
  }

  public getServiceTypeName(serviceType) {
    return (serviceType).toString();
  }

}
